import { LeadPriorityScore, SCORING_PRIORITIES } from "app/pages/sales-intelligence/domain/leads/types/lead-priority";
import type { TeamLeadScoringCriteria } from "app/pages/sales-intelligence/domain/teams/types/team-list-item";

// The lead-score tier labels the filter panel already exposes ("High" / "Medium" / "Low"). Held as
// keys rather than translated text so the builder stays pure and the tooltip owns translation.
const PRIORITY_LABEL_KEY: Partial<Record<LeadPriorityScore, string>> = {
    [LeadPriorityScore.High]: "si.lead_gen_filters.leadScores.high",
    [LeadPriorityScore.Medium]: "si.lead_gen_filters.leadScores.medium",
    [LeadPriorityScore.Low]: "si.lead_gen_filters.leadScores.low",
};

export type TeamScoringSummaryLine = {
    id: string;
    priorityLabelKey: string;
    description: string | null;
};

/**
 * One line per scoring rule — its priority tier plus the rule's business context — ordered
 * high → medium → low so the tooltip reads the same way the scoring board does.
 */
export const buildTeamScoringSummaryLines = (criteria: TeamLeadScoringCriteria | undefined): TeamScoringSummaryLine[] =>
    SCORING_PRIORITIES.flatMap((priority) => {
        const priorityLabelKey = PRIORITY_LABEL_KEY[priority];

        if (!priorityLabelKey) {
            return [];
        }

        return (criteria?.rules[priority] ?? []).map((rule, index) => ({
            id: rule.id ?? `${priority}-${index}`,
            priorityLabelKey,
            description: rule.businessContext?.translation?.trim() || null,
        }));
    });
